import {
  AddMembersToPermissionGroupDocument,
  PermissionsPermissionsDocument,
} from 'generated/resources/graphql'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export default function useMoveUserToPermissionGroup() {
  const [mutation, { loading }] = useMutation(AddMembersToPermissionGroupDocument, {
    extractorFn: (data) => data.permissionsMutations.addMembersPermissionsPermissionGroup,
  })

  const moveUserToPermissionGroup = useUnsafeCallback(
    async (variables: { permissionGroupId: string; accessId: string }) => {
      const result = await mutation({
        variables: {
          permissionGroupId: variables.permissionGroupId,
          accessIds: [variables.accessId],
        },
        refetchQueries: [PermissionsPermissionsDocument],
      })
      handleResult(result, () => {})
    },
    [mutation]
  )

  return [moveUserToPermissionGroup, loading] as const
}
